export const FIX_STREAM_SOURCE_TIMEOUT = 1000;
export const CHANGE_STREAM_SOURCE_TIMEOUT = 1000;
export const RESET_STREAM_SOURCE_TIMEOUT = 10 * 1000;

export const LIVE_DELAY = 40;
export const LIVE_OFFSET = 10;
export const LIVE_DETECT_OFFSET = 120;

export const STORAGE_KEYS = {
    VOLUME: 'stream-volume',
    MUTED: 'stream-muted',
    QUALITY: 'stream-quality',
    LANGUAGE: 'stream-language',
};